var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createUserMessage = function (message) {
    return {
        id: new Date().getTime().toString(),
        content: {
            text: message,
        },
        role: 'user',
    };
};
export var createAssistantMessage = function (botResponse) {
    return {
        id: botResponse.messageId || new Date().getTime().toString(),
        content: {
            text: botResponse.message,
        },
        role: 'assistant',
        tools: botResponse.tools,
    };
};
export var appendToMessage = function (message, botResponse) {
    return __assign(__assign({}, message), { content: {
            text: message.content.text + botResponse.message,
        } });
};
var REPORT_BY_TOOL = {
    getAverageProductSaleByBarber: 'sales-by-product',
    getBarberProductivity: 'total-gross-sales',
    getSecuredSalesReportByBarberAndShop: 'total-gross-sales',
    getSecuredSalesReportByBarber: 'total-gross-sales',
    getTopSalesByBarber: 'total-gross-sales',
    getTipsReportByBarber: 'total-gross-sales',
    getAverageServiceSaleByBarber: 'sales-by-service',
    getAverageSalePriceByBarber: 'total-gross-sales',
    getPercentageOfProductSalesByBarber: 'sales-by-product',
    getBarbersWithDataReport: 'total-gross-sales',
    getBarbersWithDiscountedSales: 'total-gross-sales',
    getBarbersWithRefundedSales: 'total-gross-sales',
    getHighestWeekdayByBarber: 'total-gross-sales',
    getHighestDailyTotalByBarber: 'total-gross-sales',
    getServiceSalesReportByBarber: 'sales-by-service',
    getServiceItemsReportByBarber: 'sales-by-service',
    getSalesReportByBarber: 'total-gross-sales',
    getSalesReportByBarberAndShop: 'total-gross-sales',
    getProductSalesReportByBarber: 'sales-by-product',
    getGiftCardSalesReportByBarber: 'total-gross-sales',
    getProductItemsReportByBarber: 'sales-by-product',
    getGrossSalesByBarberBreakdown: 'total-gross-sales',
    getGiftCardItemsReportByBarber: 'total-gross-sales',
    getBarberBreakdown: 'total-gross-sales',
};
export var getReferenceReports = function (message) {
    var _a;
    if (!((_a = message.tools) === null || _a === void 0 ? void 0 : _a.length)) {
        return [];
    }
    var referenceReportsSet = new Set(message.tools.map(function (tool) { return REPORT_BY_TOOL[tool]; }));
    return Array.from(referenceReportsSet).filter(function (report) { return report !== undefined; });
};
